<template>
    <CompassRadioGroup
        :key="`pagination-limit-${limit}`"
        :value="limit"
        :label="$t.__('listing.settings.ListingSettings.tabs.rows.number_per_page')"
        @input="
            (newValue) => {
                $emit('updateLimit', newValue);
            }
        "
    >
        <CompassRadio
            v-for="limitOption in limitOptions"
            :key="`rows-per-page-option-${limitOption}`"
            :modelValue="limitOption"
        />
    </CompassRadioGroup>
</template>

<script>
export default {
    props: {
        limit: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            limitOptions: ['25', '50', '75', '100'],
        };
    },
};
</script>
